import React from 'react';
import ZsFormikTextField from "src/components/atoms/zsTextField";
import * as Yup from "yup";
import {validate} from "src/utils/yup";

export interface IGasMeterProps {
}

export function GasMeter(props: IGasMeterProps) {

    return (
        <>

            <label><span
                style={{color: '#F00'}}>*</span> Zählerstand Gas</label>
            <ZsFormikTextField name="gasMeter"
                               autoFocus
                               validate={validate(Yup.number().typeError('Bitte den Zählerstand angeben.')
                                   .required("Bitte den Zählerstand für Gas angeben.")
                                   .min(1, "Der Zählerstand muss mindestens 1 sein.")
                                   .max(999999, "Der Zählerstand darf maximal aus 6 Ziffern bestehen."))}
                               type="onlyNumbers"
                               inputProps={{
                                   maxLength: 6,
                                   step: "1",
                                   min: 1
                               }}
                               required/>
        </>
    );

}